import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { cx } from "class-variance-authority";
import { Link } from "react-router-dom";

import type { PendoProps } from "../../utils/pendo";

import * as theme from "./PageNavMenuItem.css";

export type PageNavMenuItemProps = PendoProps & {
    label: string;
    active: boolean;
    count?: number;
} & ({ to: string; href?: never } | { href: string; to?: never });

export function PageNavMenuItem(props: PageNavMenuItemProps) {
    const { label, active, count, "data-pendo": dataPendo } = props;
    const hasCount = count !== undefined;
    // Stays mounted while empty: the fade is a transition, so it plays when a
    // count arrives but not when a row mounts with one.
    const content = (
        <>
            <span className={theme.label}>{label}</span>
            <span
                className={cx(theme.count, !hasCount && theme.emptyCount)}
                aria-hidden={!hasCount}
            >
                {count}
            </span>
        </>
    );

    return (
        <li>
            <NavigationMenu.Link
                asChild
                active={active}
                className={theme.root}
                data-pendo={dataPendo}
            >
                {props.to === undefined ? (
                    <a href={props.href}>{content}</a>
                ) : (
                    <Link to={props.to}>{content}</Link>
                )}
            </NavigationMenu.Link>
        </li>
    );
}
